import { useMemo } from "react";
import { MUI_NAV_HEIGHT } from "src/components/layout/default-layout";
import { MUI_TOP_SPACE_WITH_TICKER } from "src/components/layout/nav/constants";
import { getGlobals } from "src/constants/globals";
import { LANGUAGE } from "src/constants/locale";
import { useRouterLocale } from "src/utils/router/use-router-locale";

/**
 * This hook provides the appropriate height for the header, considering the presence of a ticker news bar.
 * In the current implementation, the ticker news bar exists only in German (DE) language mode, leading to a larger header height.
 * If the language changes to English (EN), the ticker news bar is not present, resulting in a smaller header height.
 */
export const useMuiNavHeight = () => {
    const { language } = useRouterLocale();
    const { isNewsTickerHidden } = getGlobals() ?? {};
    const isTickerEnabled = language === LANGUAGE.DE && !isNewsTickerHidden;

    const NAV_HEIGHT_VARIATION = useMemo(() => {
        return isTickerEnabled ? MUI_TOP_SPACE_WITH_TICKER : MUI_NAV_HEIGHT;
    }, [isTickerEnabled]);

    return { NAV_HEIGHT_VARIATION } as const;
};
